import React, { FC } from 'react';
import { pressImageUrls } from '../../common/models/pressImageUrls';

const PressLogosRow: FC<{ commonLink?: string }> = ({ commonLink }) => {
  return (
    <div className="logo-container">
      {pressImageUrls.map(({ url, imgStyle }) => (
        <a className="img-wrapper" href={commonLink || null}>
          <img src={url} style={{ ...imgStyle }} />
        </a>
      ))}
      <style jsx>{`
        .logo-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 15px;
        }

        @media (max-width: 1023px) {
          .logo-container {
            display: grid;
            grid: 50px 50px / repeat(3, 1fr);
            grid-row-gap: 15px;
            justify-content: center;
          }
        }

        .img-wrapper {
          display: flex;
          justify-content: center;
          padding: 25px;
        }

        @media (min-width: 1024px) {
          .img-wrapper:first-child {
            padding-left: 0;
          }
          .img-wrapper:last-child {
            padding-right: 0;
          }
        }

        .img-wrapper img {
          width: 100%;
          height: auto;
        }
      `}</style>
    </div>
  );
};

export default PressLogosRow;
